import React, { useEffect, useState, useMemo, useCallback } from "react";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import moment from "moment";
import { getActionHistory } from "../../../services/DeletedRecordsService";
import { Link, useParams } from "react-router-dom";
import { userSelectOptions } from "../../api/user";
import { downloadCSV } from "../../../helpers/dataTableHelper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button } from "react-bootstrap";

function AdminActionHistory() {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const filterStates = useMemo(() => {
    return { from: "", to: "", module: "", action_type: "", action: "" };
  }, []);

  const [reqParams, setReqParams] = useState({
    ...filterStates,
    page: currentPage,
    limit: perPage,
    sort_by: "action_at",
    sort_direction: "desc",
    keyword: "",
    user_id: id,
  });

  const [filterParams, setFilterParams] = useState(filterStates);
  const [filterValues, setFilterValues] = useState(filterStates);
  const [selectedUser, setSelectedUser] = useState("");

  const [fetch, setFetch] = useState(true);

  const filterSelectedUser = useCallback((data, id) => {
    if (data.length > 0) {
      data.forEach((element) => {
        if (element.id === parseInt(id)) {
          setSelectedUser(element.name);
        }
      });
    }
  }, []);

  const getUserList = useCallback(() => {
    userSelectOptions()
      .then((res) => {
        setUserList(res);
        filterSelectedUser(res, id);
      })
      .catch((err) => console.log(err));
  }, [setUserList, id]);

  const fetchUsers = useCallback(
    (params) => {
      setLoading(true);
      getActionHistory(params)
        .then((res) => {
          setData(res?.data?.data);
          setTotalRows(res?.data?.pagination?.totalRecords);
          //setSelectedUser(res?.data?.data[0]?.);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  useEffect(() => {
    getUserList();
  }, [getUserList]);

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams]);

  const columns = useMemo(
    () => [
      {
        name: "S.No.",
        selector: (row, index) => index + 1,
        wrap: true,
        //sortable: true,
        //sortField: "id",
      },
      {
        name: "Module",
        selector: (row) => row.action_on,
        wrap: true,
        sortable: true,
        sortField: "action_on",
      },
      {
        name: "Action Type",
        selector: (row) => row.action_type,
        wrap: true,
        sortable: true,
        sortField: "action_type",
      },
      {
        name: "Action Note",
        selector: (row) => row.action_note,
        wrap: true,
        sortable: true,
        sortField: "action_note",
      },
      {
        name: "Action",
        selector: (row) => row.action_status,
        wrap: true,
        sortable: true,
        sortField: "action_status",
      },
      {
        name: "Title",
        selector: (row) => row.title,
        wrap: true,
        sortable: true,
        sortField: "title",
      },
      {
        name: "Date",
        selector: (row) => row.action_at,
        wrap: true,
        sortable: true,
        sortField: "action_at",
      },
      {
        name: "Action by",
        selector: (row) => row.action_by,
        sortable: false,
        wrap: true,
        sortField: "action_by",
      },
    ],
    []
  );

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        page: 1,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  const onSearch = useCallback(() => {
    const params = {
      ...reqParams,
      ...filterParams,
      from:
        filterParams.from !== "" && filterParams.from !== null
          ? moment(filterParams.from).format("yyyy-MM-DD")
          : "",
      to:
        filterParams.to !== "" && filterParams.to !== null
          ? moment(filterParams.to).format("yyyy-MM-DD")
          : "",
    };
    setReqParams(params);
    filterSelectedUser(userList, params?.user_id);
    setFetch(true);
  }, [filterParams, setReqParams, setFetch, userList]);

  const onClear = useCallback(() => {
    const params = {
      ...reqParams,
      ...filterStates,
    };
    setReqParams(params);
    setFilterParams(filterStates);
    filterSelectedUser(userList, params?.user_id);
    setFetch(true);
  }, [filterStates, setFilterParams, setReqParams, setFetch, userList]);

  return (
    <>
      <div className="row">
        <div className="col-md-2 pe-0 mb-2">
          <div className="form-group">
            <label htmlFor="formGroupExampleInput">From</label>
            <div className="mb-1 form-group">
              <DatePicker
                className={`form-control`}
                wrapperClassName="d-inline"
                dateFormat="Y-MM-dd"
                maxDate={new Date()}
                peekNextMonth
                isClearable
                onCl
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Select date"
                //selected={reqParams?.registered_after}
                onFocus={(e) => e.target.blur()}
                selected={filterParams?.from ? filterParams?.from : ""}
                onChange={(date) => {
                  setFilterParams({
                    ...filterParams,
                    from: date ? date : "",
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-md-2 pe-0 mb-2">
          <div className="form-group">
            <label htmlFor="formGroupExampleInput">To</label>
            <div className=" mb-1 form-group">
              <DatePicker
                className={`form-control`}
                wrapperClassName="d-inline"
                dateFormat="Y-MM-dd"
                maxDate={new Date()}
                isClearable
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Select date"
                //selected={reqParams?.registered_after}
                onFocus={(e) => e.target.blur()}
                selected={filterParams?.to ? filterParams?.to : ""}
                onChange={(date) => {
                  setFilterParams({
                    ...filterParams,
                    to: date ? date : "",
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-md-2 pe-0 mb-2">
          <div className="form-group">
            <label htmlFor="formGroupExampleInput">Module</label>
            <select
              onChange={(e) => {
                setFilterParams({ ...filterParams, module: e.target.value });
              }}
              className="form-select"
              value={filterParams?.module}
            >
              <option value="">Select Module</option>
              <option value="candidate">Candidate</option>
              {/* <option value="comment/status">Comment/Status</option> */}
              <option value="event">Event</option>
              <option value="excel">Excel</option>
              <option value="job">Job</option>
              <option value="job_fair_event">Job fair event</option>
              <option value="plan">Plan</option>
              <option value="recruiter">Recruiter</option>
              <option value="resume">Resume</option>
              <option value="role">Role</option>
              <option value="skill">Skill</option>
              <option value="user">User</option>
            </select>
          </div>
        </div>
        <div className="col-md-2 pe-0 mb-2">
          <div className="form-group">
            <label htmlFor="formGroupExampleInput">Action Type</label>
            <select
              onChange={(e) => {
                setFilterParams({
                  ...filterParams,
                  action_type: e.target.value,
                });
              }}
              className="form-select"
              value={filterParams?.action_type}
            >
              <option value="">Select Action Type</option>
              <option value="comment/status">Comment/Status</option>
              <option value="create">Create</option>
              <option value="delete">Delete</option>
              <option value="download">Download</option>
              <option value="update">Update</option>
              <option value="email">Email</option>
            </select>
          </div>
        </div>
        {/* <div className="col-md-3 pe-0">
          <div className="form-group">
            <label htmlFor="formGroupExampleInput">Action</label>
            <select
              onChange={(e) => {
                setFilterParams({
                  ...filterParams,
                  action: e.target.value,
                });
              }}
              className="form-select"
              value={filterParams?.action}
            >
              <option value="">Select Action</option>
            </select>
          </div>
        </div> */}
        <div className="col-md-2 pe-0">
          <div className="form-group">
            <label htmlFor="formGroupExampleInput">User</label>
            <select
              onChange={(e) => {
                setFilterParams({
                  ...filterParams,
                  user_id: e.target.value,
                });
              }}
              className="form-select"
              value={
                filterParams?.user_id
                  ? filterParams?.user_id
                  : reqParams.user_id
              }
            >
              <option value="">Select User</option>
              {userList.length > 0 &&
                userList.map((jf, i) => {
                  return (
                    <option value={jf.id} key={i}>
                      {jf.name}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>
        <div className="col-md-2 pe-0">
          <label htmlFor="formGroupExampleInput"></label>
          <div className="form-group">
            <Button variant="info" onClick={onSearch}>
              <i className="fa fa-search"></i>
            </Button>
            <Button variant="danger" className="ms-2" onClick={onClear}>
              <i className="fa fa-times"></i>
            </Button>
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center mb-2 flex-wrap">
        <h4 className="fs-20 mt-2 font-w600 me-auto">
          {selectedUser + " Actions List"}
        </h4>
        <button
          onClick={() => downloadCSV(data, "user-action-history-")}
          className="btn btn-warning btn-sm me-2"
        >
          <i className="fas fa-file-csv me-1"></i> Export
        </button>

        <Link to={"/user_list"} className="btn btn-primary btn-sm">
          <i className="fa fa-arrow-left"></i> Back
        </Link>
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              //selectableRows
              persistTableHead
              //clearSelectedRows={toggleCleared}
              //conditionalRowStyles={rowStyle}
              //   onSelectedRowsChange={({ selectedRows }) => {
              //     //console.log(selectedRows)
              //     setSelectedRows(selectedRows);
              //   }}
              onSort={handleSort}
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminActionHistory;
